<template>
  <AppTextField
    class="checklist-table-title-input"
    v-model="model"
    autofocus
    maxlength="100"
    @click.stop
    @keypress.enter="$emit('enter')"
    :class="{ 'invalid': dirty && isInvalid }"
    :placeholder="placeholder"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import { useTranslation } from '@/common/utils/translation'

const { t } = useTranslation({ keyPrefix: 'project.checklist.table.ChecklistTableTitleInput' })
const { type } = defineProps<{ type: string }>()
const model = defineModel<string>()
defineEmits(['enter'])

const store = useStore()
const dirty = ref(false)
const isInvalid = computed(() => !model.value?.trim())

const placeholder = computed(() => {
  if (!isInvalid.value) return ''
  return type === 'title'
    ? t('inputPlaceholderSection')
    : t('inputPlaceholderTask')
})

watch(
  isInvalid,
  (newValue: boolean) => {
    store.commit('checklist/SET_CHECKLIST_TITLE_INPUT_INVALID', newValue)
  },
  { immediate: true },
)

watch(model, () => {
  if (!dirty.value) {
    dirty.value = true
  }
})
</script>

<style scoped>
:deep(.v-field) {
  padding: 10px 12px;
  background-color: rgb(var(--v-theme-white));
  box-shadow: inset 0 0 0 2px rgb(var(--v-theme-darkblue-500));
  border-radius: 8px;
}
.invalid :deep(.v-field) {
  box-shadow: inset 0 0 0 2px rgb(var(--v-theme-error));
}

:deep(.v-field__input) {
  padding: 0;
  min-height: 0;
}

:deep(.v-field__outline__start),
:deep(.v-field__outline__end) {
  border: none;
}
</style>
